import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import config from "./config"
import router from './router'
import { buildLoginHashUrl, getLoginReturnPath } from './router/utils'
import { usesAbiturientBearerAuth, usesCollegeBearerAuth } from './utils/auth'
import i18n from './i18n'

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		accessToken: localStorage.getItem('accessToken'),
		collegeInfo: JSON.parse(localStorage.getItem('collegeInfo')) || {},
		abiturientInfo: JSON.parse(localStorage.getItem('abiturientInfo')) || {},
		// tipoInfo: JSON.parse(localStorage.getItem('tipoInfo')) || {},
		unresolvedRequestCount: 0,
		alerts:[],
		language: localStorage.getItem('language') || 'ru',
		currentRole: localStorage.getItem('currentRole') || '',
		authMethod: localStorage.getItem('authMethod') || '',
		newAbiturientUser: localStorage.getItem('newAbiturientUser') === '1',
		gbdflData: JSON.parse(localStorage.getItem('gbdflData')) || {},
		selectedChild: null
	},

	mutations: {
		login(state, response) {
			const token = (response.data && response.data.data && response.data.data.token)
				|| (response.headers && response.headers.authorization)
				|| '';
			state.accessToken = token;
			localStorage.setItem('accessToken', state.accessToken);
			applyAuthHeaders(token, state.authMethod, state.currentRole);
		},
		setAuthMethod(state, method) {
			state.authMethod = method || '';
			if (method) {
				localStorage.setItem('authMethod', method);
			} else {
				localStorage.removeItem('authMethod');
			}
			applyAuthHeaders(state.accessToken, state.authMethod, state.currentRole);
		},
		setLanguage(state, lang) {
			localStorage.setItem('language', lang);
			state.language = lang;
		},
		setCurrentRole(state, role) {
			localStorage.setItem('currentRole', role);
			state.currentRole = role;
		},
		setCollegeInfo(state, data) {
			localStorage.setItem('collegeInfo', JSON.stringify(data));
			state.collegeInfo = data;
		},
		setAbiturientInfo(state, data) {
			localStorage.setItem('abiturientInfo', JSON.stringify(data));
			state.abiturientInfo = data;
		},
		setNewAbiturientUser(state, value) {
			const flag = Boolean(value);
			state.newAbiturientUser = flag;
			if (flag) {
				localStorage.setItem('newAbiturientUser', '1');
			} else {
				localStorage.removeItem('newAbiturientUser');
			}
		},
		// setTipoInfo(state, data) {
		// 	localStorage.setItem('tipoInfo', JSON.stringify(data));
		// 	state.tipoInfo = data;
		// },
		alert(state, {alert, adding}) {
            adding ? state.alerts.push(alert)
				: state.alerts.shift()
		},
		logout(state) {
			state.accessToken = '';
			state.collegeInfo = {};
			state.currentRole = '';
			state.gbdflData = [];
			state.selectedChild = null;
			localStorage.removeItem('collegeInfo');
			localStorage.removeItem('abiturientInfo');
			// localStorage.removeItem('tipoInfo');
			localStorage.removeItem('currentRole');
			localStorage.removeItem('accessToken');
			localStorage.removeItem('authMethod');
			localStorage.removeItem('gbdflData');
			localStorage.removeItem('newAbiturientUser');
			state.authMethod = '';
			state.newAbiturientUser = false;
			clearAuthHeaders();
		},
		setUnresolvedRequestCount(state, count) {
			state.unresolvedRequestCount = count;
		},
		setGbdflData(state, data) {
			localStorage.setItem('gbdflData', JSON.stringify(data));
			state.gbdflData = data;
		},
		setSelectedChild(state, child) {
          state.selectedChild = child;
        }
	},

	actions: {
		changeLanguage({ commit, dispatch, state }, lang) {
			if (!lang || state.language === lang) {
				return;
			}
			commit('setLanguage', lang);
			i18n.locale = lang;
			dispatch('changeBaseUrl');
		},
		changeBaseUrl({getters, state}) {
			const baseUrl = getters.getBaseUrl;
			if (usesAbiturientBearerAuth(state.currentRole, state.authMethod)) {
				axios.defaults.baseURL = baseUrl + 'api/abiturient';
				return;
			}
			if (usesCollegeBearerAuth(state.currentRole, state.authMethod)) {
				axios.defaults.baseURL = baseUrl + 'api/college';
				return;
			}
			axios.defaults.baseURL = baseUrl + (
				state.currentRole ? '/' + state.language + '/' + state.currentRole : ''
			);
		},
		alertAdd({commit}, alert) {
			commit('alert', { alert, adding: true});
			setTimeout(() => commit('alert', { alert, adding: false }), 5000);
		},
		login({commit}, response) {
			return new Promise((resolve) => {
				commit('login', response);
				resolve();
			})
		},
		async getUnresolvedRequestCount() {
			await axios.get('/request/count?payment_type=2&status_id=1&training_type_id=1&education_form_id=1&declarant_type_id=1&education_type_id=3').then((response) => {
				if(response.data.status == 'success') {
					//commit('setUnresolvedRequestCount', +response.data.data.counter);
					console.log(response);
					return 123;
				}
			});
		},
		logout({state, commit, dispatch}) {
			const role = state.currentRole;
			const returnPath = getLoginReturnPath(router.currentRoute.fullPath, role);

			commit('logout');
			dispatch('changeBaseUrl');
			location.href = buildLoginHashUrl(returnPath, role);
			location.reload();
			//router.go('/login'+(user ? '/'+user : ''));
			//router.go('/login'+(user ? '/'+user : '')+'?url='+encodeURIComponent(router.history.current.fullPath));
		},
		setSelectedChild({ commit }, child) {
          commit('setSelectedChild', child);
        }
	},

	getters: {
		getBaseUrl() {
			return config.API_URL;
		},
		getApiVersion() {
			return config.API_VERSION;
		},
		getAccessToken(state) {
			return state.accessToken;
		},
		getCurrentRole(state) {
			return state.currentRole;
		},
		getCollegeInfo(state) {
			return state.collegeInfo;
		},
		getAbiturientInfo(state) {
			return state.abiturientInfo;
		},
		// getTipoInfo(state) {
		// 	return state.tipoInfo;
		// },
		getLanguage(state) {
			return state.language;
		},
		getUnresolvedRequestCount(state) {
			return state.unresolvedRequestCount;
		},
		getGbdflData(state) {
			return state.gbdflData;
		},
		getAuthMethod(state) {
			return state.authMethod;
		},
		isNewAbiturientUser(state) {
			return state.newAbiturientUser;
		},
		usesAbiturientNewApi(state) {
			return usesAbiturientBearerAuth(state.currentRole, state.authMethod);
		},
		usesCollegeNewApi(state) {
			return usesCollegeBearerAuth(state.currentRole, state.authMethod);
		},
	}

});

function clearAuthHeaders() {
	delete axios.defaults.headers.common['X-Auth'];
	delete axios.defaults.headers.common['Authorization'];
}

function applyAuthHeaders(token, authMethod, role) {
	clearAuthHeaders();
	if (!token) {
		return;
	}
	if (usesAbiturientBearerAuth(role, authMethod) || usesCollegeBearerAuth(role, authMethod)) {
		axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
	} else {
		axios.defaults.headers.common['X-Auth'] = token;
	}
}